import { render, staticRenderFns } from "./BuyerOrderReceiving.vue?vue&type=template&id=c7e6b00a&"
import script from "./BuyerOrderReceiving.vue?vue&type=script&lang=js&"
export * from "./BuyerOrderReceiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports